export default __webpack_public_path__ + "static/media/limit-reached-cark.46923ecb.svg";